import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import axios from 'axios'
import App from './App.vue'
import Router from 'vue-router'
import Login from './components/Login.vue'
import Dashboard from './components/Dashboard.vue'
import Edit from './components/Edit.vue'

//Import Styles
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import {store} from './store'

Vue.use(Router);
Vue.use(BootstrapVue);


//Router
const routes = [
  {path: '/', component: Login},
  {path: '/dashboard', component: Dashboard},
  {path: '/edit/:id', component: Edit}
];

const router = new Router({
  routes,
  mode: 'history'
})



new Vue({
  el: '#app',
  router,
  data: {
    globalStore: store.data,
  },
  render: h => h(App)
})




// WEBPACK FOOTER //
// ./src/main.js